module.exports = __webpack_public_path__ + "img/header_right_bg.91d01dd0.png";